import { LaneInput, Maneuver } from '@kinetic-ui/data-layer';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { RecursivePartial } from 'types';
import { useSelectedManeuverLane } from '../hooks/useSelectedManeuverLane';
import { useStyles } from '../styles';
import { ManeuversByLane } from './ManeuversByLane';

export const ManeuverLaneAccordion: FunctionComponent<{
  lane: RecursivePartial<LaneInput>;
  maneuvers: RecursivePartial<Maneuver>[];
}> = ({ lane, maneuvers }) => {
  const { t } = useTranslation(['locations', 'common']);
  const classes = useStyles();
  const { selectedManeuverLane, setSelectedManeuverLane } = useSelectedManeuverLane();

  return (
    <Accordion
      expanded={selectedManeuverLane?.id === lane.id}
      key={lane.id}
      onChange={(_, expanded) => setSelectedManeuverLane(expanded ? lane : undefined)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box className={classes.laneTitle}>
          <Typography>
            {`${t('maneuversFromLane', {
              lane: lane.description,
            })}`}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        {selectedManeuverLane?.id === lane.id && <ManeuversByLane maneuvers={maneuvers} />}
      </AccordionDetails>
    </Accordion>
  );
};
